
import LookupCheckbox from 'JS/components/automotive/vehicle-lookup/steps/form/LookupCheckbox.vue';
import LookupRadio from 'JS/components/automotive/vehicle-lookup/steps/form/LookupRadio.vue';
import LookupRadioButton from 'JS/components/automotive/vehicle-lookup/steps/form/LookupRadioButton.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ITireRecommendationAnswer, ITireRecommendationQuestion } from '../types/TireRecommendation.types';

@Component({
	name: 'TireRecommendationQuestion',
	components: {
		LookupCheckbox,
		LookupRadio,
		LookupRadioButton
	}
})
export default class TireRecommendationQuestion extends Vue {

	/* Props
	============================================*/

	@Prop({ type: Object, required: true })
	readonly question: ITireRecommendationQuestion;

	@Prop({ type: Array, required: true })
	readonly answers: ITireRecommendationAnswer[];

	/* Computed
	============================================*/

	get singleAnswerOnly(): boolean {
		return this.question.answers.every(x => x.solo);
	}

	get selectedAnswers(): ITireRecommendationAnswer[] {
		return this.question.answers
			.filter(x => this.selectedAnswerIds.includes(x.id));
	}

	get soloAnswerIds(): string[] {
		return this.question.answers
			.filter(x => x.solo)
			.map(x => x.id);
	}

	/* Data
	============================================*/

	selectedAnswerIds: string[] = [];

	/* Methods
	============================================*/

	toggleAnswer(answer: ITireRecommendationAnswer, checked: boolean) {
		let selectedIds = this.selectedAnswerIds.slice(0);
		if (checked && answer.solo) {
			selectedIds = [answer.id];
		} else if (checked && !answer.solo) {
			selectedIds = selectedIds.filter(id => !this.soloAnswerIds.includes(id));
			selectedIds.push(answer.id);
		} else if (!checked) {
			selectedIds = selectedIds.filter(id => id !== answer.id);
		}
		this.selectedAnswerIds = selectedIds;
	}

	/* Lifecycle Hooks
	============================================*/

	created() {
		this.selectedAnswerIds = this.answers.map(x => x.id);
	}

	@Watch('selectedAnswers')
	selectedAnswersChanged(selectedAnswersNew) {
		this.$emit('update:answers', selectedAnswersNew);
	}
}

